import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://checkout.impulsodigitalx.shop/cart/45707755323553:1';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/7ELjrRMTGhtAmYjX9pqd4Q/MOCKUP.png';
export function HeroSection() {
  return <section className="w-full bg-[#FDF8F3] pt-20 pb-16 px-4" data-id="element-127">
      <div className="max-w-4xl mx-auto text-center" data-id="element-128">
        {/* Badge */}
        <span className="inline-block bg-[#E8EDE5] text-[#5C4033] border border-[#D4956A]/30 text-sm font-semibold px-4 py-2 rounded-full mb-6" data-id="element-129">
          🌿 Para mamás, papás y cuidadores
        </span>

        {/* Main Title */}
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-[#5C4033] mb-8" data-id="element-130">
          Crianza Montessori en Casa
        </h1>

        {/* Product Image */}
        <a href={CHECKOUT_URL} className="block mb-8" data-id="element-131">
          <img src={PRODUCT_IMAGE} alt="Crianza Montessori en Casa - Sistema completo" className="w-full max-w-2xl mx-auto rounded-lg shadow-lg hover:shadow-xl transition-shadow cursor-pointer" data-id="element-132" />
        </a>

        {/* Subtitle */}
        <p className="text-xl sm:text-2xl text-[#8B7355] mb-2 max-w-3xl mx-auto leading-relaxed font-medium" data-id="element-133">
          El sistema completo para criar con calma, autonomía y confianza
        </p>
        <p className="text-lg text-[#8B7355]/90 mb-8 max-w-2xl mx-auto italic" data-id="element-134">
          (sin gritos, sin culpas y sin improvisar)
        </p>

        {/* CTA Button */}
        <a href={CHECKOUT_URL} className="inline-block bg-[#8B9E7E] hover:bg-[#6B8068] text-white text-xl font-bold py-4 px-10 rounded-full shadow-lg hover:shadow-xl transition-all transform hover:scale-105" data-id="element-135">
          👉 SÍ, QUIERO CRIAR CON MÁS CALMA DESDE HOY
        </a>

        {/* Guarantee */}
        <div className="flex items-center justify-center gap-2 mt-6 text-[#8B7355]" data-id="element-136">
          <ShieldCheckIcon className="w-5 h-5 text-[#8B9E7E]" data-id="element-137" />
          <span className="text-sm" data-id="element-138">✅ Garantía de satisfacción de 7 días</span>
        </div>
      </div>
    </section>;
}